module.exports = __webpack_public_path__ + "cf2689513d75fb5bab9b8d29fc45c2c7.pdf";